import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TenantService } from './tenant.service';

@Injectable({ providedIn: 'root' })
export class TenantRouterService {
	constructor(
		private router: Router,
		private tenantService: TenantService
	) {}

	goHome() {
		const tenant = this.tenantService.getTenant();
		if (!tenant) {
			this.router.navigate(['']);
			return;
		}

		this.router.navigate(['/', tenant]);
	}

	goLogin() {
		const tenant = this.tenantService.getTenant();
		if (!tenant) {
			this.router.navigate(['/login']);
			return;
		}

		this.router.navigate([tenant, 'login']);
	}

	navigate(commands: string[]) {
		const tenant = this.tenantService.getTenant();
		if (!tenant) {
			this.router.navigate(['/no-subdomain']);
			return;
		}

		if (commands.length === 1) {
			const route = '/' + tenant + '/' + commands[0];
			this.router.navigate([route]);
			return;
		}

		this.router.navigate(['/', tenant, ...commands]);
	}
}
